import React, { useState, useEffect } from "react";
import { colors } from "../../../../../../../../../themes/Colors";
import SearchBar from "../../../../../../../search-bar/SearchBar";
import LinkedUserCard from "./linked-user-card/LinkedUserCard";
import BaseButtons from "../../../../../../../base-buttons/BaseButtons";
import TextInputFieldArea from "../../../../../../../text-input-field/TextInputFieldArea";

const TransferPopUp = ({
  display,
  setKeyTransferPop,
  data,
  auth,
  setLoading,
  setMessage,
  setToastPop,
  setPopUpTitle,
  setRefresh,
  refresh,
}) => {
  const [selectedUser, setSelectedUser] = useState(null);
  const [note, setNote] = useState("");

  const [linkedUsersAray, setLinkedUsersArray] = useState([]);

  const getUserVehicleList = async () => {
    try {
      const response = await fetch(
        process.env.REACT_APP_BACKEND_URL + "/userInvites/getlinkedUsers",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            // Authorization: `bearer ${token}`,
          },
          body: JSON.stringify({
            userId: data ? data.vehicleOwnerUuid : null,
          }),
        }
      );

      const respnseData = await response.json();
      if (!respnseData.error) {
        setLinkedUsersArray(respnseData.linkedUsers);
        // setToastPop(true);
      }
    } catch (err) {}
  };
  const CreateTransferKeyRequest = async () => {
    setLoading(true);
    try {
      const response = await fetch(
        process.env.REACT_APP_BACKEND_URL + "/userVehicles/tranferKeyRequest",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            // Authorization: `bearer ${token}`,
          },
          body: JSON.stringify({
            userId: data ? data.vehicleOwnerUuid : null,
            note: note !== "" ? note : "nothing",
            vheicleId: data ? data._id : null,
            keyTransferById: auth ? auth.userId : null,
            keyTransferToId: selectedUser.invitedUserId,
          }),
        }
      );

      const respnseData = await response.json();

      if (respnseData.success) {
        setLoading(false);
        setMessage(respnseData.success);
        setToastPop(true);
        setPopUpTitle("SUCCESS");
        setRefresh(refresh ? false : true);
        setSelectedUser(null);
        setKeyTransferPop(false);
        // setKeyHistoryArray(respnseData.vehicleHistory);
        // setToastPop(true);
      } else {
        setLoading(false);
        setMessage(respnseData.error);
        setToastPop(true);
        setPopUpTitle("FAILURE");
      }
    } catch (err) {
      setMessage("CHECK YOUR NETWORK CONNECTION");
      setToastPop(true);
      setPopUpTitle("FAILURE");
      setLoading(false);
    }
  };
  useEffect(() => {
    if (data) {
      getUserVehicleList();
    }
  }, [data]);
  return (
    <div
      style={{
        position: "absolute",
        height: display ? "100%" : 0,
        width: "100%",
        overflow: "hidden",
        backgroundColor: colors.white,
        top: 0,
        display: "flex",
        flexDirection: "column",
        justifyContent: "flex-start",
        alignItems: "center",
        transition: "all 0.3s",
        zIndex: 20,
      }}
    >
      <div style={{ marginTop: 60 }}>KEY TRANSFER REQUEST</div>
      <div
        style={{
          flex: 1,
          width: "100%",
          position: "relative",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <div style={{ width: "100%" }}>
          <SearchBar width={"100%"} size={"80%"} />
        </div>
        <div
          style={{
            // borderStyle: "solid",
            height: "70%",
            width: "99%",
            display: "flex",
            flexDirection: "column",
            justifyContent: "flex-start",
            alignItems: "center",
            overflowY: "scroll",
            overflowX: "hidden",
            scrollbarWidth: "none",
          }}
        >
          {selectedUser ? (
            <>
              <div style={{ minHeight: 15 }} />
              <LinkedUserCard
                username={selectedUser ? selectedUser.username : "loading"}
                contactInfo={
                  selectedUser ? selectedUser.contactNumber : "loading"
                }
                status={selectedUser ? selectedUser.role : "loading"}
              />
              <div style={{ minHeight: 15 }} />
              <TextInputFieldArea
                mini={true}
                labelTitle={"NOTE"}
                height={100}
                width={"100%"}
                size={"80%"}
                value={note}
                onChange={(e) => setNote(e.target.value)}
              />
              <div style={{ minHeight: 15 }} />
              <BaseButtons
                label={"RESELECT USER"}
                backgroundColor={colors.orangeDark}
                borderRadius={8}
                width={"90%"}
                onClick={() => setSelectedUser(null)}
                height={40}
              />
            </>
          ) : (
            <>
              {linkedUsersAray.length >= 1
                ? linkedUsersAray.map((user, index) => {
                    return (
                      <div key={index} style={{ width: "100%" }}>
                        <LinkedUserCard
                          username={user.username}
                          onSelectClick={() => setSelectedUser(user)}
                          contactInfo={user.contactNumber}
                          status={user.role}
                        />
                      </div>
                    );
                  })
                : null}

              <div style={{ padding: 50 }} />
            </>
          )}
        </div>
      </div>
      <div
        style={{
          position: "absolute",
          bottom: 0,
          zIndex: 2,
          width: "99%",
          height: 80,
          display: "flex",
          justifyContent: "space-evenly",
          alignItems: "center",
        }}
      >
        <BaseButtons
          label={"CANCEL"}
          backgroundColor={colors.orangeDark}
          borderRadius={8}
          width={"40%"}
          onClick={() => {
            setKeyTransferPop(false);
            setSelectedUser(null);
          }}
        />
        <BaseButtons
          label={"SUBMIT"}
          backgroundColor={colors.greenLight}
          borderRadius={8}
          width={"40%"}
          disabled={selectedUser ? false : true}
          onClick={() => CreateTransferKeyRequest()}
        />
      </div>
    </div>
  );
};

export default TransferPopUp;
